import { isNullOrUndefined } from "ceres/app/helper/utils";

const NotificationService = require("ceres/app/services/NotificationService");

import ValidationService from "ceres/app/services/ValidationService";
import TranslationService from "ceres/app/services/TranslationService";
import Vue from "vue";
import AddressInputGroup from "./../../AddressInputGroup.vue";

import { makeProductArray } from "~/app/helper/DataLayer";
import { mapState } from "vuex";

export default Vue.component("create-update-address", {

    components: {
        AddressInputGroup
    },

    props: {
        addressData: {
            type: Object, default() {
                return {};
            }
        }, addressModal: {
            type: Object, default() {
                return {};
            }
        }, modalType: String, addressType: String, template: String, optionalAddressFields: {
            type: Object, default: () => {
                return {};
            }
        }, requiredAddressFields: {
            type: Object, default: () => {
                return {};
            }
        }, defaultSalutation: {
            type: String, default: "male"
        }
    },

    data() {
        return {
            waiting: false
        };
    },

    computed: {
        addressList() {
            return this.$store.getters.getAddressList(this.addressType);
        }, ...mapState({
            countryList: state => state.localization.shippingCountries
        })
    },

    methods: {
        /**
         * Validate the address fields
         */
        validate() {
            ValidationService.validate(this.$refs.addressForm)
                .done(() => {
                    this.saveAddress();
                })
                .fail(invalidFields => {
                    const fieldNames = [];

                    for (const field of invalidFields) {
                        let fieldName = field.lastElementChild.innerHTML.trim();

                        fieldName = fieldName.slice(-1) === "*" ? fieldName.slice(0, fieldName.length - 1) : fieldName;
                        fieldNames.push(fieldName);
                    }

                    ValidationService.markInvalidFields(invalidFields, "error");
                    NotificationService.error(TranslationService.translate("Ceres::Template.checkoutCheckAddressFormFields", { fields: fieldNames.join(", ") }));
                });
        },

        /**
         * Save the new address or update an existing one
         */
        saveAddress() {
            if (this.modalType === "initial" || this.modalType === "create") {
                this.createAddress();
            } else if (this.modalType === "update") {
                this.updateAddress();
            }
        },

        /**
         * Update an address
         */
        updateAddress() {
            this.waiting = true;
            this._syncOptionTypesAddressData();

            if (this.addressData.gender === "public_facility") {
                this.addressData.gender = "company";
                this.addressData.isPublicFacility = "yes";
                sessionStorage.setItem("isPublicFacility", "1");
            } else {
                sessionStorage.setItem("isPublicFacility", "0");
            }

            this.$store.dispatch("updateAddress", { address: this.addressData, addressType: this.addressType })
                .then(() => {
                    this.addressModal.hide();
                    this.waiting = false;

                    if ($(".payment-method-select").length) {
                        if ($(".salutation-select-" + this.addressType).length && ($(".salutation-select-" + this.addressType).val() === "company" || $(".salutation-select-" + this.addressType).val() === "public_facility")) {
                            $(".method-list-item[data-id=\"2\"]").show();
                        } else {
                            $(".method-list-item[data-id=\"2\"]").hide();
                            $(".method-list-item[data-id=\"6000\"] label").click();
                        }
                        if ($("[data-model=\"countryId\"] select").length) {
                            if ($("[data-model=\"countryId\"] select").val() === 2) {
                                if ((App.customer !== null && App.customerClass === 4) || (typeof sessionStorage.getItem("isPublicFacility") !== "undefined" && sessionStorage.getItem("isPublicFacility") === "1")) {
                                    $(".method-list-item[data-id=\"2\"]").show();
                                } else {
                                    $(".method-list-item[data-id=\"2\"]").hide();
                                    $(".method-list-item[data-id=\"6000\"] label").click();
                                }
                            }
                        }
                    }

                    let trackingCountry = this.countryList.find(country => {
                        if (country.id === this.addressData.countryId) {
                            return country;
                        }
                        return "";
                    });

                    if (trackingCountry !== "") {
                        trackingCountry = trackingCountry.currLangName;
                    }

                    if (this.addressType === 1) {
                        dataLayer.push({
                            "event": "EE_Checkout_address", "ecommerce": {
                                "checkout": {
                                    "actionField": { "step": 2, "option": trackingCountry },
                                    "products": makeProductArray(this.$store.state.basket.items)
                                }
                            }
                        });
                    } else {
                        dataLayer.push({
                            "event": "EE_Checkout_delivery_address", "ecommerce": {
                                "checkout": {
                                    "actionField": { "step": 4, "option": trackingCountry },
                                    "products": makeProductArray(this.$store.state.basket.items)
                                }
                            }
                        });
                    }
                }, error => {
                    this.waiting = false;

                    if (error.validation_errors) {
                        this._handleValidationErrors(error.validation_errors);
                    } else if (error.error) {
                        this._handleError(error.error);
                    }
                });
        },

        /**
         * Create a new address
         */
        createAddress() {
            this.waiting = true;
            this._syncOptionTypesAddressData();

            if ($(".salutation-select").length) {
                this.addressData.isPublicFacility = $(".salutation-select-" + this.addressType + " option:selected")[0].dataset.publicfacility;
                if ($(".salutation-select-" + this.addressType + " option:selected")[0].dataset.publicfacility === "yes") {
                    this.addressData.gender = "company";
                    sessionStorage.setItem("isPublicFacility", "1");
                } else {
                    sessionStorage.setItem("isPublicFacility", "0");
                }
                $(".salutation-select-" + this.addressType + " option[value=\"public_facility\"]").val("company");
            }

            this.$store.dispatch("createAddress", { address: this.addressData, addressType: this.addressType })
                .then(() => {
                    this.addressModal.hide();
                    this.waiting = false;

                    if ($(".payment-method-select").length) {
                        if ($(".salutation-select-" + this.addressType).length && ($(".salutation-select-" + this.addressType).val() === "company" || $(".salutation-select-" + this.addressType).val() === "public_facility")) {
                            $(".method-list-item[data-id=\"2\"]").show();
                        } else {
                            $(".method-list-item[data-id=\"2\"]").hide();
                            $(".method-list-item[data-id=\"6000\"] label").click();
                        }

                        if ($("[data-model=\"countryId\"] select").length) {
                            if ($("[data-model=\"countryId\"] select").val() === 2) {
                                if ((App.customer !== null && App.customerClass === 4) || (typeof sessionStorage.getItem("isPublicFacility") !== "undefined" && sessionStorage.getItem("isPublicFacility") === "1")) {
                                    $(".method-list-item[data-id=\"2\"]").show();
                                } else {
                                    $(".method-list-item[data-id=\"2\"]").hide();
                                    $(".method-list-item[data-id=\"6000\"] label").click();
                                }
                            }
                        }
                    }

                    let trackingCountry = this.countryList.find(country => {
                        if (country.id === this.addressData.countryId) {
                            return country;
                        }
                        return "";
                    });

                    if (trackingCountry !== "") {
                        trackingCountry = trackingCountry.currLangName;
                    }

                    if (this.addressType === 1) {
                        dataLayer.push({
                            "event": "EE_Checkout_address", "ecommerce": {
                                "checkout": {
                                    "actionField": { "step": 2, "option": trackingCountry },
                                    "products": makeProductArray(this.$store.state.basket.items)
                                }
                            }
                        });
                    } else {
                        dataLayer.push({
                            "event": "EE_Checkout_delivery_address", "ecommerce": {
                                "checkout": {
                                    "actionField": { "step": 4, "option": "Checkout_delivery_address" },
                                    "products": makeProductArray(this.$store.state.basket.items)
                                }
                            }
                        });
                    }
                }, error => {
                    this.waiting = false;

                    if (error.validation_errors) {
                        this._handleValidationErrors(error.validation_errors);
                    } else if (error.error) {
                        this._handleError(error.error);
                    }
                });
        },

        _handleValidationErrors(validationErrors) {
            ValidationService.markFailedValidationFields(this.$refs.addressForm, validationErrors);

            let errorMessage = "";

            for (const value of Object.values(validationErrors)) {
                errorMessage += value + "<br>";
            }

            NotificationService.error(errorMessage);
        },

        _handleError(error) {
            if (error.code === 11) {
                NotificationService.error({ code: error.code, message: "" });
                window.location.reload();
            } else if ([210, 211].indexOf(error.code) !== -1) {
                NotificationService.error({ code: error.code, message: error.message });
            } else this._handleValidationErrors(error);
        },

        _syncOptionTypesAddressData() {

            if (typeof this.addressData.options !== "undefined") {
                for (const optionType of this.addressData.options) {
                    switch (optionType.typeId) {
                    case 1: {
                        if (!isNullOrUndefined(this.addressData.vatNumber) && this.addressData.vatNumber !== optionType.value) {
                            optionType.value = this.addressData.vatNumber;
                        }

                        break;
                    }
                    case 4: {
                        if (!isNullOrUndefined(this.addressData.telephone) && this.addressData.telephone !== optionType.value) {
                            optionType.value = this.addressData.telephone;
                        }
                        break;
                    }
                    case 6: {
                        if (!isNullOrUndefined(this.addressData.postNumber) && this.addressData.postNumber !== optionType.value) {
                            optionType.value = this.addressData.postNumber;
                        }
                        break;
                    }
                    case 9: {
                        if (!isNullOrUndefined(this.addressData.birthday) && this.addressData.birthday !== optionType.value) {
                            optionType.value = this.addressData.birthday;
                        }
                        break;
                    }
                    case 11: {
                        if (!isNullOrUndefined(this.addressData.title) && this.addressData.title !== optionType.value) {
                            optionType.value = this.addressData.title;
                        }
                        break;
                    }
                    case 12: {
                        if (!isNullOrUndefined(this.addressData.contactPerson) && this.addressData.contactPerson !== optionType.value) {
                            optionType.value = this.addressData.contactPerson;
                        }
                        break;
                    }
                    }
                }
            }
        },

        emitInputEvent(event) {
            this.$emit("input", event);

            this.checkInputEventForUnmarkFields(event);
        },

        checkInputEventForUnmarkFields(event) {
            const genderCondition = event.field === "gender" && event.field.value !== this.addressData.gender;
            const countryCondition = event.field === "countryId" && event.field.value !== this.addressData.countryId;
            const pickupCondition = event.field === "showPickupStation" && event.field.value !== this.addressData.showPickupStation;

            if (genderCondition || countryCondition || pickupCondition) {
                ValidationService.unmarkAllFields(this.$refs.addressForm);
            }
        }
    }
});
